// custom-quill-editor.component.ts
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { QuillModule } from 'ngx-quill';
import { QuillConfiguration } from 'src/app/components/models/quillConfiguration';


@Component({
  selector: 'app-custom-quill-editor',
  template: `
  <div class = "my-3">
  <label class="pb-1"><mat-label>{{props['label']}} <mat-icon *ngIf="to['tooltip']"
                  matTooltip="{{ to['tooltip'] }}"
                  class="tooltip-icon "
                  matTooltipPosition="right"
                  >help</mat-icon></mat-label></label>
    <quill-editor
        [formlyAttributes]="field" 
        styles="{'height': '120px'}"
        class="content-editor"
        modules="quillConfiguration"
        placeholder="props['placeholder']"
        [(ngModel)]="editorValue"
        readOnly="to['disabled']"
        [formControl]="formControl" [formlyAttributes]="field"  
    ></quill-editor>
  </div>
  `,
  standalone:true,
  imports:[
    FormsModule,ReactiveFormsModule,MatTooltipModule,MatIconModule,CommonModule,
    CustomQuillEditorComponent,
    MatFormFieldModule,FormlyModule,
  ]
})
export class CustomQuillEditorComponent extends FieldType<FieldTypeConfig>  {

  quillOptions = {
    // Configure Quill options here
  };
  quillConfiguration=QuillConfiguration;
  editorValue: string = '';
  ngOnInit() {
    if (this.field.formControl) {
        this.editorValue = this.field.formControl.value || '';
    }
  }
}
